module.exports = __webpack_public_path__ + "static/images/food-and-beverage.5216eb20ed78ae14f55b9c068d14d234.svg";